import React, { useEffect, useState } from "react";

import {
  Paper,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Switch,
  Typography,
  TableContainer,
  TableHead,
  TableSortLabel,
  useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserNotificationPrefs, activeOrDeactiveNotification } from "../../store/action/userNotificationPreference/userNotificationPreferenceAction";
import EnhancedTableHead from './EnhancedTableHead'
import { headCells } from './Headcells'
import AlertDialog from "../../components/Alert/AlertDialog";
import Loading from "../../components/Loading/Loading";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
    padding: 24,
    backgroundColor: theme.palette.background.main,
  },
}));

const UserNotificationPreference = ({ user_id }) => {
  const classes = useStyle();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('id')
  const { getUserNotificationPrefsItem, loading } = useSelector((state) => state.userNotificationPrefs);
  const [activeOpen, setActiveOpen] = useState(false);
  const [deActiveOpen, setDeActiveOpen] = useState(false);
  const [staffNotify, setStaffNotify] = useState(false);
  const [prefId, setPrefId] = React.useState(0)

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order,
  ) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const aActiveClose = () => {
    setActiveOpen(false);
  };
  const dActiveClose = () => {
    setDeActiveOpen(false);
  };
  const alertActiveResponse = (id) => {
    dispatch(activeOrDeactiveNotification(user_id, id, 1));
    setStaffNotify(true);
    dispatch(getUserNotificationPrefs(user_id, orderBy, order));
  };
  const alertDeActiveResponse = (id) => {
    dispatch(activeOrDeactiveNotification(user_id, id, 0));
    setStaffNotify(true);
    dispatch(getUserNotificationPrefs(user_id, orderBy, order));
  };

  const onHandlActive = (id) => {
    setActiveOpen(true);
    setPrefId(id);
  };

  const onHandlDeActive = (id) => {
    setDeActiveOpen(true);
    setPrefId(id);
  };
  const onChangeSwitch = (event, rowId) => {
    if (event.target.checked) {
      onHandlActive(rowId);
    } else {
      onHandlDeActive(rowId);
    }
    dispatch(getUserNotificationPrefs(user_id, orderBy, order));
  }


  useEffect(() => {
    dispatch(getUserNotificationPrefs(user_id, orderBy, order));
  }, [dispatch, user_id, orderBy, order]);

  const handleSorting = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <>
      {loading && <Loading open={loading} />}

      <Paper>
        <Box display="flex" alignItems="center" justifyContent="space-between" p={2} className={classes.root}>
          <Box>
            {/* Left content like Title or Search */}
            <Typography variant="h6" color="primary"> User Notification Preferences</Typography>
          </Box>
        </Box>

        {/* Table */}
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center" style={{ width: "10%", background: theme.palette.thead }}>#</TableCell>
                <TableCell align="center" style={{ width: "10%", background: theme.palette.thead }}>Action</TableCell>
                <TableCell sortDirection={orderBy === "title" ? order : false} style={{ width: "70%", background: theme.palette.thead }}>
                  <TableSortLabel
                    active={orderBy === "title"}
                    direction={orderBy === "title" ? order : "asc"}
                    onClick={() => handleSorting("title")}
                  >
                    Title
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {getUserNotificationPrefsItem?.data &&
                getUserNotificationPrefsItem.data.map((row, index) => (
                  <TableRow key={index} >
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="center">
                      <Switch color="primary" onChange={(e) => onChangeSwitch(e, row.id)} checked={!row?.pref_id > 0} />
                    </TableCell>
                    <TableCell align="left"><Typography>{row.title}</Typography></TableCell>
                  </TableRow>
                ))}

              {!getUserNotificationPrefsItem?.data && (
                <TableRow>
                  <TableCell colSpan={3} align="center" style={{ padding: 20 }}>
                    <Typography variant="body2" color="textSecondary">
                      Sorry, User Notification Preference not available!
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <AlertDialog
        id={prefId}
        open={activeOpen}
        close={aActiveClose}
        response={alertActiveResponse}
        title="Active Notification Preference"
        description="Are you sure you want to active this Notification Preference?"
        buttonName="Active"
      />

      <AlertDialog
        id={prefId}
        open={deActiveOpen}
        close={dActiveClose}
        response={alertDeActiveResponse}
        title="Deactive Notification Preference"
        description="Are you sure you want to deactive this Notification Preference?"
        buttonName="Deactive"
      />
    </>
  );
};

export default UserNotificationPreference;
